import React, { Component } from 'react'
import { Form, Checkbox } from 'antd';

export class CarReturnBefore extends Component {
    state = {
        return_vehicle_early: 1,
    }

    onChange = return_vehicle_early => {
        this.setState({
            return_vehicle_early
        });
    };

    render() {
        const { return_vehicle_early } = this.state;
        const { unlimitEdit } = this.props;
        return <>
            <div className="title-contract title-special">7. Trả xe trước hạn hợp đồng*</div>
            <Form.Item wrapperCol={24} label="">
                <div className="vat-fee">
                    <Checkbox disabled={!unlimitEdit} onChange={() => this.onChange(1)} checked={return_vehicle_early}>Có</Checkbox>
                    <Checkbox disabled={!unlimitEdit} onChange={() => this.onChange(0)} checked={!return_vehicle_early}>Không có</Checkbox>
                </div>
            </Form.Item>

        </>
    }
}
